import $ from 'jquery';
import fetch from 'utils/fetch';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';

const INITIAL_INTERVAL_IN_MS = 5000;
const RETRY_INTERVAL_IN_MS = 10000; // Every 10 seconds

export default function bind(
  replaceWith = url => <DownloadButton url={url} />
) {
  $('.loading.pdf').each((_, element) => {
    const $element = $(element);

    const url = $element.attr('data-url');
    if (url && url.length) {
      // Try to fetch pdf and render download button if found
      setTimeout(
        () => tryFetchPdf($element, url, replaceWith),
        INITIAL_INTERVAL_IN_MS // Starting with a delay
      );
    }
  });
}

export function bindListPdfButtons() {
  $('.loading.pdf').each((_, element) => {
    const $element = $(element);

    const url = $element.attr('data-url');
    const key = $element.attr('key');
    const style = $element.attr('style');

    const onClicked = evt => {
      evt.stopPropagation();
    };

    const replaceWith = url => (
      <ListPDFButton key={key} style={style} href={url} onClick={onClicked} />
    );

    if (url && url.length) {
      // Try to fetch pdf and render download button if found
      setTimeout(
        () => tryFetchPdf($element, url, replaceWith, true),
        INITIAL_INTERVAL_IN_MS // Starting with a delay
      );
    }
  });
}

function tryFetchPdf($button, url, replaceWith, inList) {
  fetch(url, { redirect: 'manual' })
    .then(_ => updateButtonIfFound($button, url, replaceWith, inList))
    .catch(_ => {
      // Retry it
      setTimeout(
        () => tryFetchPdf($button, url, replaceWith, inList),
        RETRY_INTERVAL_IN_MS
      );
    });
}

function updateButtonIfFound($button, url, replaceWith, inList = false) {
  const content = ReactDOMServer.renderToString(replaceWith(url));

  // Replace label content
  $button.replaceWith(content);

  if (inList) {
    $('.rendered-pdf').on('click', evt => {
      evt.stopPropagation();
    });
  }
}

const DownloadButton = ({ url }) => {
  if (url.includes('aast')) {
    return (
      <a href={url} target="_blank" className="ui basic button icon download">
        <i className="file pdf outline icon" />
      </a>
    );
  }

  return (
    <a href={url} target="_blank" className="ui button icon labeled">
      <i className="file pdf outline icon" />
      PDF
    </a>
  );
};

DownloadButton.propTypes = {
  url: PropTypes.string.isRequired,
};

export const ListPDFButton = ({ key, style, href, onClick }) => (
  <div key={key} style={style}>
    <a
      href={href}
      target="_blank"
      className="ui basic rendered-pdf button"
      onClick={onClick}
    >
      <i className="file pdf outline icon" />
      PDF
    </a>
  </div>
);



// WEBPACK FOOTER //
// ./src/plugins/pdf-button.js